import React from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import CreateContactInformation from './CreateContactInformation';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.booking.list,
  height: '100%',
  padding: '1rem 1rem 1rem 1rem',
  overflow: 'auto',

  [theme.breakpoints.up('xs')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('md')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('lg')]: {
    height: '67.3vh'
  }
}));

const ContactInformation = ({
  configuration = {},
  activeStep = null,
  contactsInfo = null,
  setContactsInfo = () => {},
  setIsFormValid = () => {},
  participants = {},
  setParticipants = () => {},
  disableKeyFields = false,
  setBookingPersonRadio = () => {},
  isEventFree = false,
  isEventIlias = false
}) => {
  return (
    <>
      <StyledBox>
        <CreateContactInformation
          configuration={configuration}
          contactsInfo={contactsInfo}
          setContactsInfo={setContactsInfo}
          setIsFormValid={setIsFormValid}
          participants={participants}
          setParticipants={setParticipants}
          activeStep={activeStep}
          disableKeyFields={disableKeyFields}
          setBookingPersonRadio={setBookingPersonRadio}
          isEventFree={isEventFree}
          isEventIlias={isEventIlias}
        />
      </StyledBox>
    </>
  );
};
export default ContactInformation;
